import React, { useCallback, useState } from 'react';
import {
  Row, Col, Button, ButtonGroup,
} from 'reactstrap';

import { Intl } from 'components';
import SingleUpload from '../Single';

export default ( { values, submitErrors, onUpload } ) => {
  const [selectedTab, setSelectedTab] = useState( 1 );

  const selectTab = useCallback( ( tab ) => {
    if ( selectedTab !== tab ) {
      setSelectedTab( tab );
    }
  }, [selectedTab] );
  return (
    <>
      <Row>
        <Col md={10} className="m-auto">
          <ButtonGroup className="w-100 break-word">
            <Button
              color="app-default"
              size="app-sm"
              block
              active={selectedTab === 1}
              onClick={() => selectTab( 1 )}
            >
              {!!values && !!values.introductionFile && !!values.introductionFile.id && <i className="fa fa-check mr-2" />}
              <Intl id="introduction" />
            </Button>
            <Button
              color="app-default"
              size="app-sm"
              block
              className="m-0"
              active={selectedTab === 2}
              onClick={() => selectTab( 2 )}
            >
              {!!values && !!values.optionsFile && !!values.optionsFile.id && <i className="fa fa-check mr-2" />}
              <Intl id="options" />
            </Button>
            <Button
              color="app-default"
              size="app-sm"
              className="m-0"
              block
              active={selectedTab === 3}
              onClick={() => selectTab( 3 )}
            >
              {!!values && !!values.farewellFile && !!values.farewellFile.id && <i className="fa fa-check mr-2" />}
              <Intl id="farewell" />
            </Button>
          </ButtonGroup>
        </Col>
      </Row>

      {selectedTab === 1 && (
        <SingleUpload
          field="introductionFile"
          submitErrors={submitErrors}
          onUpload={onUpload}
        />
      )}
      {selectedTab === 2 && (
        <SingleUpload
          field="optionsFile"
          submitErrors={submitErrors}
          onUpload={onUpload}
        />
      )}
      {selectedTab === 3 && (
        <SingleUpload
          field="farewellFile"
          submitErrors={submitErrors}
          onUpload={onUpload}
        />
      )}
    </>
  );
};
